// extracted by mini-css-extract-plugin
module.exports = {"content":"submitarequest_content__yObCw"};